import { render, staticRenderFns } from "./Gollac.vue?vue&type=template&id=73c7eb67&"
import script from "./Gollac.vue?vue&type=script&lang=js&"
export * from "./Gollac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports